const trackerUrl = "https://newsroom.hansemerkur.de/matomo/";
const siteId = "1";

window._paq = window._paq || [];

window._paq.push(["setDocumentTitle", document.domain + "/" + document.title]);
window._paq.push(["setDoNotTrack", true]);
window._paq.push(["disableCookies"]);
window._paq.push(['trackPageView']);
window._paq.push(['enableLinkTracking']);

(function () {
	window._paq.push(["setTrackerUrl", trackerUrl + "matomo.php"]);
	window._paq.push(["setSiteId", siteId]);
	const d = document,
		g = d.createElement("script"),
		s = d.getElementsByTagName("script")[0];
	g.async = true;
	g.src = trackerUrl + "matomo.js";
	s.parentNode.insertBefore(g, s);
})();
